import type { ThemeOptions } from '@mui/material';

export const breakpoints = {
  values: {
    xs: 0,
    sm: 640,
    md: 1024,
    lg: 1440,
    xl: 1680,
  },
} satisfies NonNullable<ThemeOptions['breakpoints']>;
